export default __webpack_public_path__ + "static/media/times-solid.f88eb0e1.svg";